import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import usePageTitle from '../hooks/usePageTitle';

const About = () => {
  const { t } = useLanguage();
  usePageTitle('About');
  return (
    <div className="-mt-16">
      <section className="relative pt-40 md:pt-48 pb-16 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-mesh" />
        <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight mb-6 text-gradient-animated">
            {t('about.title')}
          </h1>
          <p className="text-base md:text-lg text-gray-400 leading-relaxed">
            {t('about.body')}
          </p>
          <div className="mt-10">
            <Link to="/careers" className="shimmer-wrap inline-flex items-center gap-2 px-6 py-3 text-gray-300 font-medium text-sm rounded-full border border-white/[0.12] hover:bg-white/[0.06] hover:border-white/25 hover:text-white transition-all duration-300">
              {t('footer.about.join')}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
